import Viewer from 'viewerjs'

import { NOTE_IMAGE_VIEWER_CONTAINER } from './NoteImageViewer.component'
import { Injectable } from '@angular/core'
import { Config } from '../../../universal-config'


@Injectable()
export class NoteImageViewerService {
  container: HTMLElement
  viewerInstance: Viewer
  FILE_SERVER_URL;

  constructor(
    private config: Config,
  ) {
    this.FILE_SERVER_URL = this.config.get('BOX_URL');
  }

  setImage(attachmentUrl: string): boolean {
    if (!attachmentUrl) { return false }

    this.container = this.getContainer()

    if (this.container) {
      this.container.innerHTML = ''

      const image: HTMLImageElement = document.createElement('img')

      image.src = `${this.FILE_SERVER_URL}${attachmentUrl}`;

      this.container.appendChild(image)

      return true
    }

    return false
  }

  showImage(): boolean {
    if (this.getImage() !== false) {
      const toolbar: any = {
        zoomIn: {
          tooltip: 'Zoom in',
        },
        zoomOut: {
          tooltip: 'Zoom out',
        },
        oneToOne: {
          tooltip: 'Actual size',
        },
        reset: {
          tooltip: 'Optimized view',
        },
        prev: false,
        play: false,
        next: false,
        rotateLeft: {
          tooltip: 'Rotate',
        },
        rotateRight: {
          tooltip: 'Rotate',
        },
        flipHorizontal: {
          tooltip: 'Flip horizontal',
        },
        flipVertical: {
          tooltip: 'Flip vertical',
        },
        print: {
          tooltip: 'Print',
        },
      };

      this.viewerInstance = new Viewer(this.container.querySelector('img'), {
        inline: false,
        navbar: false,
        toolbar,
        hidden() {
          const viewerContainer = document.querySelector('.viewer-container')

          if (viewerContainer) {
            viewerContainer.remove()
          }
        },
      })

      this.viewerInstance.show(true)

      return true
    }

    return false
  }

  destroyViewer() {
    if (this.viewerInstance) {
      this.viewerInstance.destroy()
    }
  }

  private getContainer() {
    return document.getElementById(NOTE_IMAGE_VIEWER_CONTAINER)
  }

  private getImage(): HTMLImageElement|false {
    if (this.container) {
      return this.container.querySelector('img')
    }

    return false
  }
}
